import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import { ToggleButton } from "styled_components/Common/ToggleButton";
import { ClipSelector } from "styled_components/SVG/ClipSelector";
import { MonthlySelector } from "styled_components/SVG/MonthlySelector";
import { DocSelector } from "styled_components/SVG/DocSelector";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const theme1 = {
  account: "#416ba9",
  support: "#8060a9",
  storage: "#008388",
  billing: "#a8ad00",
  Cool_Gray_Med_1: "#a2a9ad",
  Cool_Gray_Light_3: "#edefef",
};
const TicketDetailsStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
  padding: 10px;
  flex: 1;
  white-space: pre-line;
  background: ${(props) => props.theme.componentBackground};
  color: ${(props) => props.theme.defaultFontColor};
  .ticket-view-picker-wrapper {
    top: -20px;
    right: 0;
    position: absolute;
  }
  .ticket-description-wrapper {
    background: ${(props) => props.theme.white};
    height: 300px;
    width: 100%;
    padding: 10px;
  }
  .attachment-component-wrapper {
    height: 100%;

    .file-name {
      height: 20px;
      padding-bottom: 10px;
    }

    .file-name:hover {
      color: $Dark_Purple;
      font-weight: bold;
      cursor: pointer;
    }
  }

  .right {
    flex: 1;
    height: 100%;
    border: 1px solid red;
  }

  .ScrollbarsCustom-Track {
    right: 0px !important;
    top: 0px !important;
  }
  .ScrollbarsCustom-ThumbY {
    background-color: ${(props) => props.theme.support} !important;
    width: 6px !important;
  }
  .ScrollbarsCustom-TrackY:before {
    border-left: none;
  }
  .ScrollbarsCustom-TrackY {
    background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
    box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
      1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
    width: 6px !important;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    padding: 10px;
    .ticket-view-picker-wrapper {
      top: -24px;
    }
    .ticket-description-wrapper {
      height: 325px;
      padding: 10px;
    }

    .ScrollbarsCustom-Track {
      right: 0px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 8px !important;
    }

    .ScrollbarsCustom-TrackY {
      background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
      box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
        1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
      width: 8px !important;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    padding: 10px;
    .ticket-view-picker-wrapper {
      top: -33px;
    }
    .ticket-description-wrapper {
      height: 550px;
      padding: 10px;
    }
    .ScrollbarsCustom-Track {
      right: 0px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 10px !important;
    }
    .ScrollbarsCustom-TrackY {
      background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
      box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
        1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
      width: 10px !important;
    }
  }
`;

export const TicketDetails = ({
  ticketDetails,
  updateTitle,
  getEventCardParams,
  attachments,
  eventId,
  ticketRequestType,
}) => {
  const [selected, setSelected] = useState("description");
  const position = "left";

  let description = "";

  description = ticketDetails?.description;

  useEffect(() => {
    updateTitle(selected);
  }, [selected]);

  return (
    <TicketDetailsStyle className="ticket-details-wrapper">
      <div className="ticket-view-picker-wrapper">
        <div className="ticket-view-picker">
          <ToggleButton
            module="support"
            id="toggle-slider-5"
            theme={theme1}
            groupName="togglers-5"
          >
            <DocSelector
              id="hourly-selector-1"
              module="support"
              theme={theme1}
              className={"hourly"}
              value="description"
              onClick={setSelected}
            />
            <ClipSelector
              id="daily-selector-1"
              module="support"
              theme={theme1}
              position={position}
              className={"daily"}
              value="attachment"
              onClick={setSelected}
              enabled={
                !attachments || attachments?.length === 0 ? "false" : "true"
              }
            />
            <MonthlySelector
              id="monthly-selector-1"
              module="support"
              theme={theme1}
              value="event"
              position="left"
              className={"monthly"}
              onClick={setSelected}
              enabled={eventId ? "true" : "false"}
            />
          </ToggleButton>
        </div>
      </div>
      {selected === "description" && (
        <div className="ticket-description-wrapper">
          <ScrollView>
            <div className="ticket-details">
              <div className="row">
                <div className="value footer20">{description}</div>
              </div>
            </div>
          </ScrollView>
        </div>
      )}
      {selected === "attachment" && (
        <div className="ticket-description-wrapper">
          <div className="attachment-component-wrapper">
            <ScrollView purple>
              {ticketRequestType === "support" &&
                attachments.map((attachment) => (
                  <a
                    href={`${BASE_URL}/support/attachment/${attachment?.hash}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="file-name numbers5">
                      {attachment.fileName}
                    </div>
                  </a>
                ))}
            </ScrollView>
          </div>
        </div>
      )}
      {selected === "event" && (
        <div className="ticket-description-wrapper">
          {eventId && getEventCardParams(ticketDetails)}
        </div>
      )}
    </TicketDetailsStyle>
  );
};
// LargeInfoDisplay.propTypes = {
// 	type: string.isRequired,
// };

// LargeInfoDisplay.defaultProps = {};
